import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="notfound-page">
      <main className="notfound-main">
        <div className="notfound-content">
          <div className="notfound-text">
            <h1 className="notfound-oops">Oops!</h1>
            <h2 className="notfound-title">Come back to the homepage</h2>
            <p className="notfound-desc">
              Looks like our astronaut is lost in space.
            </p>
            <div className="notfound-buttons">
              <button className="btn-primary" onClick={() => navigate('/')}>
                Back to Homepage
              </button>
            </div>
          </div>
          <div className="notfound-illustration">
            <svg
              width="400"
              height="400"
              viewBox="0 0 400 400"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              {/* Astronaut SVG */}
              <circle cx="200" cy="200" r="160" fill="#FFB800" opacity="0.1" />
              <circle cx="200" cy="180" r="70" fill="#1a3e52" />
              <circle cx="200" cy="180" r="50" fill="#2a5a75" />
              <circle cx="200" cy="180" r="30" fill="#fff" />
              <circle cx="185" cy="170" r="6" fill="#1a3e52" />
              <circle cx="215" cy="170" r="6" fill="#1a3e52" />
              <path d="M190 195 Q200 205 210 195" stroke="#1a3e52" strokeWidth="4" fill="none" />
              <rect x="170" y="250" width="60" height="80" rx="10" fill="#FFB800" />
              <rect x="180" y="330" width="10" height="40" rx="5" fill="#1a3e52" />
              <rect x="210" y="330" width="10" height="40" rx="5" fill="#1a3e52" />
              <circle cx="145" cy="250" r="15" fill="#FFB800" />
              <circle cx="255" cy="250" r="15" fill="#FFB800" />
              <circle cx="145" cy="250" r="8" fill="#fff" />
              <circle cx="255" cy="250" r="8" fill="#fff" />
              {/* Stars */}
              <circle cx="80" cy="80" r="4" fill="#FFB800" />
              <circle cx="320" cy="60" r="6" fill="#FFB800" />
              <circle cx="340" cy="140" r="3" fill="#FFB800" />
              <circle cx="60" cy="180" r="5" fill="#FFB800" />
              <circle cx="90" cy="320" r="4" fill="#FFB800" />
              <circle cx="310" cy="300" r="5" fill="#FFB800" />
            </svg>
          </div>
        </div>
      </main>
    </div>
  );
};

export default NotFound;